import { observer } from "mobx-react-lite";
import React from "react";
import { FilesCard } from "./FilesCard";
import { ProjectDetailsCard } from "./ProjectDetailsCard";

export const ProjectDetails = observer(function ProjectDetails() {
  return (
    <React.Fragment>
      <ProjectDetailsCard />
      <FilesCard />
    </React.Fragment>
  );
});
